import { render, staticRenderFns } from "./TemuConf.vue?vue&type=template&id=ca634486&scoped=true"
import script from "./TemuConf.vue?vue&type=script&lang=js"
export * from "./TemuConf.vue?vue&type=script&lang=js"
import style0 from "./TemuConf.vue?vue&type=style&index=0&id=ca634486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca634486",
  null
  
)

export default component.exports